<template>
  <div class="grid">
    <div class="g-col-12 g-col-lg-8">
      <template v-if="apiData.rooms?.length">
        <template v-for="(room, index) in apiData.rooms" :key="room.slug">
          <RoomItem :room="room" :index="index" />
        </template>
      </template>
      <FormKit
        id="inventory-form"
        v-model="values"
        #="{ state: { valid } }"
        type="form"
        form-class="grid devis-form"
        :actions="false"
        :incomplete-message="false"
      >
        <FormKit
          id="inventoryInformation"
          type="textarea"
          name="inventoryInformation"
          outer-class="g-col-12"
          :label="__('Further information:', 'smdt')"
          :placeholder="__('Further information:', 'smdt')"
          :value="values.inventoryInformation"
        />
      </FormKit>
    </div>
    <div class="g-col-12 g-col-lg-4">
      <InventorySummary />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'
import RoomItem from '../components/RoomItem.vue'
import InventorySummary from '../components/InventorySummary.vue'
import { watch } from 'vue'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

export default {
  name: 'StageFour',
  components: { InventorySummary, RoomItem },
  computed: {
    ...mapWritableState(useStagesStore, ['values']),
    ...mapState(useStagesStore, [
      'apiData',
      'currentStageData',
      'updateState',
      'updateValues',
    ]),
  },
  mounted() {
    // const node = this.$formkit.get('inventory-form')
    // const isValid = node.context.state
    //
    // watch(isValid, (val) => {
    //   const { valid } = val
    //   this.setValid(valid)
    // })
  },
  methods: {
    ...mapActions(useStagesStore, ['setValid']),
    __,
  },
}
</script>

<style scoped lang="scss">
.grid {
  @include media-breakpoint-down(sm) {
    --#{$prefix}gap: 0;
  }
}
</style>
